/** EN catalog — copy carried from the approved Access/Shell design files. */
export const en: Record<string, string> = {
  'app.product': 'Zoyaar',
  'app.productFa': 'زویار',
  'app.clinicTag': 'CLINIC',
  'app.loading': 'Getting things ready…',
  'app.configError': "Couldn't load this deployment's configuration.",
  'app.retry': 'Try again',

  'nav.today': 'Today',
  'nav.calendar': 'Calendar',
  'nav.patients': 'Patients',
  'nav.payments': 'Payments',
  'nav.family': 'Family',
  'nav.clinicSetup': 'Clinic setup',
  'nav.railNote': 'Always labelled — never icon-only.',

  'signin.title': 'Sign in',
  'signin.subEmail': 'With the email and password your clinic gave you.',
  'signin.subMobile': 'We text a sign-in code to your mobile number.',
  'signin.methodMobile': 'Mobile number',
  'signin.methodEmail': 'Email',
  'signin.identifierLabel': 'Email or username',
  'signin.identifierHelp': 'The address or username your clinic administrator registered for you.',
  'signin.passwordLabel': 'Password',
  'signin.passwordHelp': 'Given to you by your clinic. You can change it after signing in.',
  'signin.phoneLabel': 'Mobile number',
  'signin.phoneHelp': 'The number your clinic administrator registered for you.',
  'signin.phoneInvalid':
    'Enter a valid mobile number — e.g. 0912 123 4567, or the full international form starting with +.',
  'signin.otpReqFailed':
    'The code couldn’t be requested — nothing you typed was lost. Check the number and the connection, then try again.',
  'signin.cta': 'Sign in',
  'signin.sendCode': 'Send the code',
  'signin.sending': 'Signing in…',
  'signin.otpNote': 'Continuing sends one SMS to this number.',
  'signin.forgot': 'I forgot my password',
  'signin.underAuth':
    'Staff accounts are created by your clinic administrator. If you don’t have your sign-in details yet, ask them — there is no self-registration.',
  'signin.required': 'required',
  'signin.optional': 'optional',

  'signin.wrongCreds': 'That email and password don’t match',
  'signin.wrongCredsBody':
    'Check both and try again — the password your clinic gave you is case-sensitive. If it keeps failing, “I forgot my password” below resets it safely.',
  'signin.netTitle': 'Couldn’t reach the clinic system',
  'signin.netBody':
    'Your details are kept exactly as you typed them. Check your connection and try again.',
  'signin.inactiveTitle': 'This account is not active',
  'signin.inactiveBody':
    'Your access to this clinic has been turned off. Your records and notes are unaffected. Please talk to your clinic administrator — they can reactivate access in a moment.',
  'signin.notReadyTitle': 'This account has a setup step pending',
  'signin.notReadyBody':
    'A setup step is still pending on this account in the clinic system, and sign-in can’t finish until an administrator completes it. Nothing about your account is lost.',
  'signin.wrongSurfaceTitle': 'This account doesn’t sign in here',
  'signin.wrongSurfaceBody':
    'The clinic system recognises the account, but it isn’t a clinic staff account. If you work at this clinic, ask your administrator to check how your account was created.',
  'signin.setNewTitle': 'Set your own password',
  'signin.setNewSub':
    'The password your clinic gave you was temporary and it matched. Choose your own now — sign-in completes in the same step, for',
  'signin.setNewCta': 'Set password and sign in',
  'signin.setNewNote':
    'Only this account is affected. Going back keeps everything you typed; the temporary password still works for this step until it is replaced.',
  'signin.setNewUnchanged': 'The new password must be different from the temporary one.',
  'signin.setNewRejected': 'The clinic system didn’t accept this password. Check the rules above.',
  'signin.setNewNotRequired':
    'This account no longer needs a password change — sign in with your current password.',
  'signin.backToSignin': 'Back to sign in',
  'signin.successTitle': 'Welcome, {name}',
  'signin.successBody': 'You are signed in to {clinic}.',
  'signin.successGoing': 'Taking you to Today…',

  'otp.codeTitle': 'Check your phone',
  'otp.codeSubA': 'Enter the code we texted to ',
  'otp.codeSubB': ' — the number stays as you typed it.',
  'otp.codeLabel': 'The 6-digit code',
  'otp.codeHelp': 'Sent by SMS. It fills in by itself from the message on most phones.',
  'otp.invalid':
    'That code isn’t right. Check the newest SMS — an older message may still be open, or the code may have expired.',
  'otp.resend': 'Send a new code',
  'otp.resent': 'A new code is on its way',
  'otp.resentBody': 'Only the newest code works from now on. The older SMS can be ignored.',
  'otp.throttledTitle': 'Please wait before asking for another code',
  'otp.throttledBody': 'The clinic system asks you to try again in about {wait}.',
  'otp.resendWait': 'You can ask again in {wait}',
  'otp.cooldownTitle': 'A code was just sent',
  'otp.cooldownBody':
    'Give the SMS a moment to arrive — you can ask for another one shortly. The code already sent still works.',
  'otp.windowTitle': 'Too many codes requested for this number',
  'otp.windowBody':
    'The clinic system has stopped sending new codes to this number for now. Wait, then try again — or sign in with your email and password instead.',
  'otp.lockedTitle': 'Too many wrong codes',
  'otp.lockedBody':
    'This sign-in attempt is locked because the code was entered incorrectly too many times. A new code will not help until the wait is over.',
  'otp.throttledGeneric': 'The clinic system asked us to wait before trying again.',
  'otp.serverWaitNote':
    'Any wait shown here comes from the clinic system — Zoyaar never invents one.',
  'otp.notSentTitle': 'The code was not sent',
  'otp.notSentBody': 'Please try again. The number you typed is kept.',
  'otp.notSentNote': 'The last code was not sent — you can ask again once the wait ends.',
  'otp.resendFailedTitle': 'The code could not be sent again',
  'otp.resendFailedBody':
    'Nothing you typed was lost. Check the connection and try again — the code already sent may still work.',
  'otp.verify': 'Verify the code',
  'devOtp.title': 'Development only — SMS is not connected yet',
  'devOtp.body': 'The clinic system returned this code with the request. Enter it below.',
  'devOtp.copy': 'Copy code',
  'devOtp.copied': 'Copied',

  'forgot.title': 'Reset your password',
  'forgot.sub':
    'Enter the email you sign in with. We text a code to the mobile number registered on the account — your password is never sent anywhere.',
  'forgot.emailHelp':
    'The email address on your clinic account. The response looks the same whether or not an account exists.',
  'forgot.cta': 'Text me a code',
  'forgot.codeSubA': 'Enter the code we texted to the mobile number registered on ',
  'forgot.codeSubB': '. The address stays as you typed it.',
  'forgot.expiredTitle': 'That reset is no longer valid',
  'forgot.expiredBody':
    'The code was used, expired, or the reset was started again elsewhere. Begin once more from your email — a fresh code is texted.',
  'forgot.underForgot':
    'If the mobile number on your account is out of date, your clinic administrator can correct it — that is not something this page can do.',
  'forgot.newPwTitle': 'Choose a new password',
  'forgot.newPwSub': 'It replaces the old one everywhere, right away.',
  'forgot.newPwLabel': 'New password',
  'forgot.newPwHelp': 'Password rules come from the clinic system and are shown here as you type.',
  'forgot.confirmLabel': 'Confirm new password',
  'forgot.confirmHelp': 'Type it a second time, so one typo can’t lock you out.',
  'forgot.mismatch':
    'These two don’t match yet. Nothing you typed was cleared — check the second field.',
  'forgot.matchOk': 'Both match.',
  'forgot.setCta': 'Set the new password',
  'forgot.doneTitle': 'Password changed',
  'forgot.doneBody':
    'Every session on every device was signed out for safety. Sign in with the new password now — nothing else about your account changed.',
  'forgot.doneCta': 'Go to sign in',
  'forgot.rulesTitle': 'Password requirements',
  'forgot.rulesNote':
    'These are the clinic system’s own rules — the same ones it checks when you save. Zoyaar adds none of its own.',
  'pw.ruleLength': 'Between {min, number} and {max, number} characters',
  'pw.ruleDifferent.current': 'Different from your current password',
  'pw.ruleDifferent.temporary': 'Different from the temporary password',
  'pw.ruleDifferent.previous': 'Different from your previous password (checked when you save)',
  'pw.rulePending': 'not checked yet',
  'pw.ruleMet': 'met',
  'pw.ruleUnmet': 'not met',

  'account.title': 'My account',
  'account.sub': 'Who you are here, and the few things you can change yourself.',
  'account.fullName': 'Full name',
  'account.noName': 'Name not set',
  'account.role': 'Clinic role',
  'account.roleNone': 'Not set in your staff profile yet.',
  'account.roleUnavailable': 'Kept in your staff profile, which your role here cannot open.',
  'account.roleFailed': 'Your staff profile could not be read just now.',
  'account.roleHint': 'Your professional job at this clinic, from your staff profile.',
  'account.clinic': 'Clinic',
  'account.switchClinic': 'Switch clinic',
  'account.identity': 'Signed in as',
  'account.admin': 'Clinic administrator',
  'account.language': 'Language',
  'account.password': 'Password',
  'account.passwordValue': 'Change the password you sign in with',
  'help.nav': 'User guides',
  'help.title': 'User guides',
  'help.sub': 'The guides to the clinic panel — open one in the browser, or download it.',
  'help.audience': 'For: {who}',
  'help.version': 'Version {version} · {date}',
  'help.view': 'Open',
  'help.download': 'Download',
  'account.signOut': 'Sign out',

  'change.title': 'Change password',
  'change.sub': 'You stay signed in here after changing it.',
  'change.current': 'Current password',
  'change.currentHelp': 'The one you sign in with now — even if the clinic created it.',
  'change.ready':
    'All three fields are needed, the new password must meet the rules, and the two new ones must match, before the button works.',
  'change.cta': 'Change password',
  'change.wrongCurrent':
    'That isn’t your current password. Nothing was changed — check it and try again.',
  'change.unchanged': 'The new password must be different from the current one.',
  'change.doneBody':
    'This session stays signed in. Any other session on other devices was signed out and needs the new password.',
  'change.doneSignedOut':
    'The password changed and every session, including this one, was signed out. Sign in again with the new password.',
  'change.unavailable':
    'Password changes aren’t available right now — the clinic system reported a temporary outage. Nothing was changed; try again shortly.',
  'change.notApplicable':
    'This account signs in without a password, so there is nothing to change here.',

  'chooser.title': 'Which clinic are you working in?',
  'chooser.sub':
    'You belong to more than one clinic. Everything you see and do stays inside the clinic you choose — you can switch any time from your account.',
  'chooser.suspended': 'Access suspended',
  'chooser.inactive': 'Temporarily inactive',
  'chooser.unnamed': 'Clinic (name not set yet)',
  'chooser.memberSince': 'Member since {date}',
  'chooser.open': 'Work in this clinic',

  'today.title': 'Today',
  'today.subTherapist':
    'Your day at a glance — sessions and unfinished work arrive with the scheduling and delivery builds.',
  'today.cardBookingsTitle': 'Your day’s sessions',
  'today.cardBookingsBody':
    'The day list appears here once clinic-wide scheduling reads arrive (in build).',
  'today.cardWorkTitle': 'Needs attention',
  'today.cardWorkUnpaid':
    '{n, plural, =0 {No delivered session is waiting for a payment record.} one {# delivered session is waiting for its payment to be recorded.} other {# delivered sessions are waiting for their payment to be recorded.}}',
  'today.cardWorkOpen': 'Open the unpaid queue',

  'placeholder.title': 'Nothing here yet',
  'placeholder.body':
    '{area} is part of a later build phase. Everything you set up elsewhere stays ready for it.',

  'entry.brandedSignIn': 'Signing in to {clinic}.',
  'entry.notFoundTitle': 'No clinic at this address',
  'entry.notFoundBody':
    'This link does not belong to any clinic. Check it with the person who gave it to you, or open the app from its main address.',
  'entry.notFoundCta': 'Open the app',
  'entry.deniedTitle': 'You are not a member of this clinic',
  'entry.deniedBody':
    'Your account has no access to {clinic}. Ask that clinic’s administrator to add you, or continue in one of your own clinics.',
  'entry.deniedChoose': 'Go to my clinics',
  'entry.copy': 'Copy address',
  'entry.copied': 'Copied',
  'error.forbiddenTitle': 'This part belongs to someone else',
  'error.notFoundTitle': 'There is no page here',
  'error.notFoundBody':
    'The address doesn’t match anything in the clinic app — it may be mistyped or out of date. Nothing was lost.',
  'error.notFoundCta': 'Go to Today',
  'error.forbiddenBody':
    'Your role does not include this area. If you need a change here, ask a clinic administrator — they can do it in a moment.',
  'error.authzDownTitle': 'Couldn’t check your access',
  'error.authzDownBody':
    'The clinic system is temporarily unreachable, so nothing was opened. Try again in a moment.',
  'error.inactiveTitle': 'This clinic is temporarily inactive',
  'error.inactiveBody':
    'The Zoyaar platform has paused this clinic. Nothing about your account changed — when the clinic is reactivated, your access returns exactly as it was.',
  'error.inactiveChoose': 'Choose another clinic',
  'error.noAccessTitle': 'No clinic access',
  'error.noAccessBody':
    'This account is not a member of any clinic. Ask your clinic administrator to add you, then try again.',
  'ctx.lostTitle': 'Your clinic context changed',
  'ctx.lostBody':
    'The clinic you were working in is no longer available to this account — your membership there ended or was suspended. Nothing from it is shown any more.',
  'ctx.lostInactive': 'The clinic you were working in has been paused by the platform.',
  'ctx.changedTitle': 'Clinic changed in another tab',
  'ctx.changedBody':
    'You switched to {clinic} in another tab. This tab has stopped sending requests so nothing goes to the wrong clinic. Reload to continue there, or sign out.',
  'ctx.changedToNone':
    'You left the clinic selection in another tab. This tab has stopped sending requests. Reload to choose again, or sign out.',
  'ctx.reload': 'Reload this tab',
  'error.suspendedTitle': 'This account is not active in this clinic',
  'error.suspendedBody':
    'Your access here has been turned off. Your records and notes are untouched. A clinic administrator can reactivate access.',
  'common.loading': 'Loading…',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.notNow': 'Not now',
  'common.unconfirmedWrite':
    'We couldn\u2019t confirm whether this was saved. Reload before trying again.',
};
